import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_CALADO } from '../../../../../../config/tables'

export default function TablaCamionesCaladosView () {
  return <MuiTable id={TABLA_CAMIONES_CALADO} />
}
